<template>
    <div class="content-body">

        <div class="container ">


            <md-card>
                <md-card-header class="background-primary">
                    <div>
                        <div class="md-title"> นโยบายความเป็นส่วนตัว</div>
                    </div>
                </md-card-header>

                <md-card-content>

                    <h2>การใช้คุกกี้ของ ก.ล.ต.</h2>
                    <div class="mb-3">คุกกี้
                        คือไฟล์ข้อความขนาดเล็กที่เว็บไซต์ที่คุณเข้าเยี่ยมชมวางไว้บนคอมพิวเตอร์ของคุณ
                        คุกกี้ได้ถูกใช้อย่างมากมาย เพื่อที่จะทำให้เว็บไซต์ทำงาน หรือเพิ่มประสิทธิภาพการทำงาน
                        รวมทั้งเก็บข้อมูลให้กับเจ้าของเว็บไซต์
                        ตารางด้านล่างนี้แสดงคุกกี้และวัตถุประสงค์การใช้งานของคุกกี้แต่ละชนิดที่ ก.ล.ต. ใช้
                    </div>

                    <div class="mb-5">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td style="min-width:200px;">
                                    <strong>คุกกี้</strong>
                                </td>
                                <td>
                                    <strong>ชื่อ</strong>
                                </td>
                                <td>
                                    <strong>วัตถุประสงค์การใช้งาน</strong>
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    Universal Analytics (Google)
                                </td>
                                <td>
                                    _ga<br> _gali<br> _gat<br> _gid
                                </td>
                                <td>
                                    คุกกี้เหล่านี้ถูกใช้เพื่อเก็บรวบรวมข้อมูลการใช้งานของผู้เข้าชมเว็บไซต์&nbsp; ก.ล.ต.
                                    ใช้ข้อมูลเหล่านี้มาประมวลผลจัดทำรายงานเพื่อพัฒนาปรับปรุงเว็บไซต์
                                    คุกกี้เหล่านี้จะเก็บข้อมูลที่ไม่ระบุตัวตนของบุคคล ตัวอย่างข้อมูลที่จัดเก็บ เช่น
                                    จำนวนผู้เข้าชมเว็บไซต์ หน้าเว็บไซต์ที่เข้าเยี่ยมชม เป็นต้น<br> <a
                                        href="https://support.google.com/analytics/answer/6004245">ข้อมูลเพิ่มเติม:
                                    การรักษาความปลอดภัยและความเป็นส่วนตัวของข้อมูลของ Google</a>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>

                    <div class="mb-5">
                        <h2>จะเปลี่ยนการตั้งค่าคุกกี้ได้อย่างไร </h2>
                        <div class="mb-3">
                            <div>คุณสามารถเปลี่ยนการตั้งค่าคุกกี้ของคุณได้ทุกเวลา โดยการกดที่ไอคอน “C” บนหน้าเว็บไซต์
                                จากนั้น เลื่อนปุ่ม เพื่อเลือก “เปิด” หรือ “ปิด” แล้ว คลิก “บันทึกและปิด” โดยคุณอาจต้อง
                                refresh หน้าจออีกครั้ง เพื่อให้การเปลี่ยนแปลงตัวเลือกของคุณทำงาน
                            </div>

                            <div>
                                นอกจากนี้
                                เว็บเบราว์เซอร์ส่วนใหญ่ยอมให้คุณควบคุมคุกกี้ส่วนใหญ่ผ่านการกำหนดค่าที่เว็บเบราว์เซอร์เอง
                                หากคุณต้องการศึกษาข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้หรือวิธีการดูการกำหนดค่าคุกกี้
                                สามารถดูได้ที่ <a href="http://www.aboutcookies.org/" target="_blank">www.aboutcookies.org</a>
                                หรือ <a target="_blank"
                                        href="http://www.allaboutcookies.org/">www.allaboutcookies.org</a></div>
                        </div>
                    </div>


                    <div>
                        <div>ค้นหาวิธีการจัดการคุกกี้ของเบราว์เซอร์ต่าง ๆ ได้จากลิงก์เหล่านี้</div>
                        <ul>
                            <li>
                                <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&amp;hl=en">Google
                                    Chrome</a></li>
                            <li><a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy">Microsoft
                                Edge</a></li>
                            <li>
                                <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">Mozilla
                                    Firefox</a></li>
                            <li>
                                <a href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies">Microsoft
                                    Internet Explorer</a></li>
                            <li><a href="https://www.opera.com/help/tutorials/security/privacy/">Opera</a></li>
                            <li><a href="https://support.apple.com/en-gb/safari">Apple Safari</a></li>
                        </ul>
                    </div>

                    <div>
                        <div>สำหรับเบราว์เซอร์อื่น
                            สามารถค้นหาข้อมูลเพิ่มเติมได้จากเว็บไซต์ของผู้พัฒนาเบราว์เซอร์นั้น
                        </div>

                        <div>หากคุณไม่ต้องการให้ Google Analytics ติดตามข้อมูลคุณในเว็บไซต์ต่าง ๆ
                            ที่คุณเยี่ยมชม โปรดไปที่ <a href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>
                        </div>
                    </div>


                </md-card-content>
            </md-card>


        </div>


    </div>
</template>


<script>
    export default {
        name: 'Policy'
    }
</script>


<style scoped lang="scss">
    @import "../assets/css/colors";

    .content-body {
        background-image: url("../assets/images/bg.png");
        background-color: $smoke;
        background-attachment: fixed;
    }

    .md-card {
        border-radius: 8px;
    }

    .md-card-header {
        border-radius: 8px 8px 0 0;
    }
</style>
